import { render, staticRenderFns } from "./FlyCourse.vue?vue&type=template&id=3678629a&scoped=true"
import script from "./FlyCourse.vue?vue&type=script&lang=js"
export * from "./FlyCourse.vue?vue&type=script&lang=js"
import style0 from "./FlyCourse.vue?vue&type=style&index=0&id=3678629a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678629a",
  null
  
)

export default component.exports